export default __webpack_public_path__ + "static/media/fl1.d1bf2f9f.png";